import React, { useEffect, useState , useRef  } from 'react';
import {
  PaginationComponent,
  Spinner,
  Tables,
  TabsComponent,
   AutocompleteComponent,
  Inputs,
} from '../../../../../../Components';
import { PropertiesProfileMPITabsData } from './PropertiesProfileMPITabsData';
import { GetParams, bottomBoxComponentUpdate } from '../../../../../../Helper';
import {
  GetPropertyMPI,
  GetSummaryPropertyMPIData,
} from '../../../../../../Services/PropertyMPI/PropertMPI';
import { GetLookupItemsByLookupTypeName } from "../../../../../../Services";
import { headerData } from './PropertyMPIHeaderData';
import { Tab, Tabs, withStyles } from '@material-ui/core';
import { PropertySummaryMPIComponent } from './PropertySummaryMPIComponent';
import { useTranslation } from 'react-i18next';

const parentTranslationPath = 'PropertiesView';
const translationPath = 'MPI.';

export const PropertyProfileMPIComponent = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [selectedTab, setSelectedTab] = useState('Summary');
  const [summaryData, setSummaryData] = useState({ result: [], totalCount: 0 });
  const initialFilter = {
    propertyId: +GetParams('id'),
    pageIndex: 1,
    pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
    categoryIdentifier: 2,
    unitType : null , 
    bedrooms : null  , 
  };
  const [filter, setFilter] = useState(initialFilter);
  const onTabChanged = (_e, newTap) => {
    setActiveTab(newTap);
    setFilter((filter) => ({
      ...filter,
      pageIndex: 1,
      pageSize: parseInt(localStorage.getItem('Pagination')) || 25,
      categoryIdentifier: newTap === 0 ? 2 : 1,
      unitType : null , 
      bedrooms : null  , 
    }));
    setSelectedTab('Summary');
    setSummaryData({ result: [], totalCount: 0 });
    setData({ result: [], totalCount: 0 });
  };
    const searchTimer = useRef(null);
    const [isLoadingData, setIsLoadingData] = useState({
      unitTypes: false,
    });
    const [itemsData, setItemsData] = useState({
      unitTypes: [],
    });

    const [selectedFilter, setSelectedFilter] = useState({
      unitType: null,
      bedrooms: null,
    });

  const { t } = useTranslation(parentTranslationPath);

  const getPropertyMPI = async () => {
    setIsLoading(true);
    const result = await GetPropertyMPI(filter);
    setData(result);
    setIsLoading(false);
  };

  const handleChangeTabSummary = (_event, newValue) => {
    setSelectedTab(newValue);
    setFilter((filter) => ({
      ...initialFilter,
      categoryIdentifier: filter.categoryIdentifier,
    }));
  };

  const getSummaryPropertyMPI = async () => {
    setIsLoading(true);
    const result = await GetSummaryPropertyMPIData(filter);
    if (!(result.status && result.status !== 200)) {
      setSummaryData(result);
    }
    setIsLoading(false);
  };

   const getLookupItemsByName = async (lookUpName, key) => {
     setIsLoadingData((item) => ({ ...item, [key]: true }));
     const result = await GetLookupItemsByLookupTypeName({
       lookUpName,
       pageSize: 100,
       pageIndex: 1,
     });
     if (!(result && result.status && result.status !== 200)) {
       setItemsData((item) => ({
         ...item,
         [key]: (result && result.result) || [],
       }));
     } else setItemsData((item) => ({ ...item, [key]: [] }));
     setIsLoadingData((loading) => ({ ...loading, [key]: false }));
   };
   useEffect(() => {
     if (!filter.unitType && !filter.bedrooms)
       setSelectedFilter((prev) => ({
         ...prev,
         unitType: null,
         bedrooms: null,
       }));
   }, [filter]);

  useEffect(() => {
    if (selectedTab === 'Summary') {
      getSummaryPropertyMPI();
    } else {
      getPropertyMPI();
    }
  }, [filter]);

  useEffect(() => {
    if (selectedTab === 'Summary') {
      bottomBoxComponentUpdate(
        <PaginationComponent
          pageIndex={filter.pageIndex - 1}
          totalCount={summaryData.totalCount}
          pageSize={filter.pageSize}
          onPageIndexChanged={(index) =>
            setFilter((filter) => ({ ...filter, pageIndex: index }))
          }
          onPageSizeChanged={(size) =>
            setFilter((filter) => ({ ...filter, pageSize: size }))
          }
          perPageText='row-per-page'
          translationPath=''
          parentTranslationPath='Shared'
        />
      );
    }
  }, [summaryData.totalCount, filter]);

  const CustomTab = withStyles({
    root: {
      textTransform: 'none', // Prevent text transformation
    },
  })(Tab);

  return (
    <div className="properties-information-wrapper childs-wrapper b-0 properties-specification-wrapper">
      <>
        <TabsComponent
          data={PropertiesProfileMPITabsData}
          labelInput="tab"
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          themeClasses="theme-curved"
          currentTab={activeTab}
          onTabChanged={onTabChanged}
        />
        <div>
          <div className="title-section p-2">
            <div className="sub-title-properties-MPI">MPI</div>
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChangeTabSummary}
            >
              <CustomTab
                value="Summary"
                label={t(`${translationPath}summary`)}
                sx={{ textTransform: "none" }}
              />
              <CustomTab
                value="Details"
                label={t(`${translationPath}details`)}
                sx={{ textTransform: "none" }}
              />
            </Tabs>
          </div>
            <div class="d-flex-v-center-h-end mb-3">
              <div className="px-2">
                <AutocompleteComponent
                  key={`unitTypes`}
                  selectedValues={selectedFilter?.unitType}
                  idRef={`unitTypeRef`}
                  multiple={false}
                  inputPlaceholder={"filter-by-unit-type"}
                  wrapperClasses="w-50-unset mb-2"
                  data={itemsData && itemsData.unitTypes}
                  displayLabel={(option) =>
                    (option && option.lookupItemName) || ""
                  }
                  onChange={(e, newValue) => {
                    setSelectedFilter((prev) => ({
                      ...prev,
                      unitType: newValue,
                    }));
                    setFilter((prev) => ({
                      ...prev,
                      unitType: newValue ? newValue.lookupItemName : null,
                    }));
                  }}
                  isLoading={isLoadingData.unitTypes}
                  withLoader
                  withoutSearchButton
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  onOpen={() => {
                    if (itemsData?.unitTypes?.length === 0)
                      getLookupItemsByName("UnitType", "unitTypes");
                  }}
                />
              </div>
              <div className="px-2">
                <Inputs
                  idRef={`bedroomsRef${1}`}
                  value={selectedFilter?.bedrooms || ""}
                  type={"number"}
                  wrapperClasses="w-50-unset mb-2"
                  min={0}
                  onInputChanged={(e) => {
                    let newValue = e.target.value;
                    newValue =
                      newValue && newValue === "" ? null : parseInt(newValue);
                    if (newValue < 0) newValue = newValue * -1;
                    setSelectedFilter((prev) => ({
                      ...prev,
                      bedrooms: newValue,
                    }));
                    searchTimer.current = setTimeout(() => {
                      setFilter({
                        ...filter,
                        bedrooms: newValue || null,
                      });
                    }, 1000);
                  }}
                  inputPlaceholder={t(`filter-by-bedrooms`)}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  onKeyUp={(event) => {
                    if (searchTimer.current) clearTimeout(searchTimer.current);
                    let newValue = event.target.value;
                    newValue =
                      newValue && newValue === "" ? null : parseInt(newValue);
                    if (newValue < 0) newValue = newValue * -1;
                    searchTimer.current = setTimeout(() => {
                      setFilter({
                        ...filter,
                        bedrooms: newValue || null,
                      });
                    }, 1000);
                  }}
                  onKeyDown={() => {
                    if (searchTimer) clearTimeout(searchTimer.current);
                  }}
                />
              </div>
            </div>
          {selectedTab === "Details" ? (
            <Tables
              data={data.result}
              totalItems={data.totalCount}
              headerData={headerData}
              isLoading={isLoading}
              itemsPerPage={filter.pageSize}
              activePage={filter.pageIndex - 1}
              onPageIndexChanged={(index) =>
                setFilter((filter) => ({ ...filter, pageIndex: index + 1 }))
              }
              onPageSizeChanged={(size) =>
                setFilter((filter) => ({ ...filter, pageSize: size }))
              }
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
              defaultActions={[]}
            />
          ) : (
            <PropertySummaryMPIComponent
              isLoading={isLoading}
              summaryData={summaryData?.result || []}
              parentTranslationPath={parentTranslationPath}
              translationPath={translationPath}
            />
          )}
        </div>
      </>
    </div>
  );
};
